import { chakra } from "@chakra-ui/react";

export const FilterBtn = chakra("button", {
  base: {
    boxShadow: "0px 0px 0px 1px #122B6914",
    backgroundColor: "#ffffff",
    width: "88px",
    height: "36px",
    borderRadius: "4px",
    padding: "4px 6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
  },
});
